import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Open early connections to the font + image hosts so the LCP image and
// fonts start downloading sooner (cuts TLS/DNS time on mobile).
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/sv4PPPdd8k5sXGYK6SGgV6/nutricion_hook.webp';
(function optimizeCriticalPath() {
  if (typeof document === 'undefined') return;
  const head = document.head;
  const hosts = [{
    href: 'https://cdn.magicpatterns.com',
    crossOrigin: false
  }, {
    href: 'https://fonts.googleapis.com',
    crossOrigin: false
  }, {
    href: 'https://fonts.gstatic.com',
    crossOrigin: true
  }];
  hosts.forEach(({
    href,
    crossOrigin
  }) => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = href;
    if (crossOrigin) link.crossOrigin = 'anonymous';
    head.appendChild(link);
  });
  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.as = 'image';
  preload.href = HERO_IMAGE;
  preload.setAttribute('fetchpriority', 'high');
  head.appendChild(preload);
})();
render(<App data-id="element-216" />, document.getElementById('root'));